export const queryGetUserProductRecommendation = `
  query MyQuery ($where: QueryProductRecommendationsWhereWhereConditions, $orderBy: [QueryProductRecommendationsOrderByOrderByClause!], $first: Int = 10, $page: Int) {
    productRecommendations(first: $first, page: $page, where: $where, orderBy: $orderBy) {
      data {
        product {
          id
          images {
            source
          }
          title
          statuses {
            name
          }
          createdBy
          createdAt
        }
        agentId
        agent {
          id
          name
        }
        userId
        response
        createdAt
      }
      paginatorInfo {
        total
        currentPage
        count
        lastPage
      }
    }
  }
`